import React, { useState } from 'react'

import { Button, PopUp } from '@ketch-com/deck'
import { Box, Divider, FormControlLabel, Stack, Typography } from '@mui/material'
import { Banner, Checkbox } from '@ketch-com/deck'

type Props = {
  onSubmit: (includePII: boolean) => void
  onCancel: () => void
}

export const ConfirmDownloadPIDataModal: React.FC<Props> = ({ onSubmit, onCancel }) => {
  const [includePII, setIncludePII] = useState(false)

  return (
    <PopUp
      title="Export"
      popUpWidth="550px"
      variant="dialog"
      onClose={onCancel}
      popUpActionChildren={
        <>
          <Button color="secondary" size="large" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" size="large" onClick={() => onSubmit(includePII)}>
            Export
          </Button>
        </>
      }
    >
      <Divider />
      <Typography>
        By default, personal information (PI) is excluded from the DSR export.
        <br />
        To include PI in the export package, check the box below.
      </Typography>
      <Stack spacing={1}>
        <FormControlLabel
          control={<Checkbox checked={includePII} onChange={e => setIncludePII(e.target.checked)} />}
          label="Include Data Subjects Personal Information"
        />
        {includePII && (
          <Box sx={{ '& .MuiAlert-root': { width: '100%' } }}>
            <Banner
              title="Warning! You are downloading personal information"
              children="Make sure you handle it securely and in compliance with Privacy Policies."
              severity="warning"
              icon="OInfo"
            />
          </Box>
        )}
      </Stack>
      <Divider />
    </PopUp>
  )
}
